export interface CensusTableCell {
  value: string;
  errorMessage?: string;
  warningMessage?: string;
}

export enum FamilyMemberStatus {
  VALID = 'VALID',
  INVALID = 'INVALID',
  WARNING = 'WARNING',
}

export interface FamilyMember {
  row: string;
  /** @deprecated use the status field instead */
  invalid: boolean;
  cells: CensusTableCell[];
  status: FamilyMemberStatus;
}

export interface CensusFamiliesTable {
  headers: string[];
  families: FamilyMember[][];
  statistics: StatisticsValues;
}

export interface StatisticsValues {
  total: number;
  employees: number;
  dependents: number;
  errors: number;
}

export interface StatisticCard {
  value: number;
  title: string;
}

export interface StatisticsFields {
  total: StatisticCard;
  employees: StatisticCard;
  dependents: StatisticCard;
  errors: StatisticCard;
}

export interface ExistingCensusInfo {
  exist: boolean;
  valid: boolean;
  familyAmount: number;
  hasPrePopulatedCensus: boolean;
}
